import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
// @ts-expect-error untyped dependency
import { resetReviewSubmitted } from '../../actions/ReviewsActions'; // @ts-expect-error untyped dependency

// @ts-expect-error untyped dependency
import { getReviewSubmitted } from '../../selectors/reviews';
export default function WriteReviewButton({
  className,
  disabled = false,
  offeringType,
  onClick,
  reviewability,
  size = 'sm'
}) {
  const dispatch = useDispatch();
  const isReviewable = reviewability.isReviewable();
  const reason = reviewability.getUnreviewableReason();
  const reviewSubmitted = useSelector(getReviewSubmitted);
  useEffect(() => {
    return () => {
      dispatch(resetReviewSubmitted());
    };
  }, [dispatch]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: reviewSubmitted ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.reviews.unreviewable.reviewSubmitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-assets-ui.themes.details.reviews.unreviewable.${reason}`,
        options: {
          offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`)
        }
      }),
      disabled: reviewSubmitted ? false : isReviewable,
      placement: "left",
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: "tertiary",
        size: size,
        disabled: reviewSubmitted || disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.reviews.write.button"
        })
      })
    })
  });
}